// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__qSXO1","extraPadding":"FAQ_extraPadding__EnM3Q"};